import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CreditCardForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAddCreditCard} from "../../actions/AccountApiActions";
import {Map} from "immutable";
import { StripeProvider, Elements } from 'react-stripe-elements';
import { getStripePublishableKey } from "../../config";

function validateForm(values) {
  let errors = Map();
  return errors.toJS();
}

class AddCreditCardFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      errors: [],
      submitting: false
    }
  }

  handleSubmit(paymentMethodId) {
    let values = {accountId: this.props.accountId, paymentMethodId: paymentMethodId};
    this.setState({submitting: true});
    this.props.addPaymentMethod(values)
      .then((response) => {
        if (response.data.addPaymentMethod.errors.length <= 0) {
          this.setState({submitting: false});
          this.props.cancelAddCreditCard();
        } else {
          let better_errors = {_error: "Failed to add card"}
          this.setState({errors: better_errors, submitting: false});
        }
      })
      .catch((err) => {
        let better_errors = {_error: "Failed to add card"}
        this.setState({errors: better_errors, submitting: false});
      });
  }

  handleCancel() {
    this.props.cancelAddCreditCard();
  }

  render() {
    // Need to load the jurisdiction for this account.
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const apiKey = getStripePublishableKey(data.billingShop.id);
    return (
      <StripeProvider apiKey={apiKey}>
        <Elements>
          <Form
            clientSecret={data.billingSetupPaymentCredentials.clientSecret}
            shopName={data.billingShop.name}
            submitting={this.state.submitting}
            errors={this.state.errors}
            validate={validateForm}
            onSubmit={this.handleSubmit.bind(this)}
            onCancel={this.handleCancel.bind(this)}
            />
        </Elements>
      </StripeProvider>
    )
  }

}

const ADD_PAYMENT_METHOD = gql`
  mutation addPaymentMethod($data: PaymentMethodIdInput!) {
    addPaymentMethod(input: $data) {
      errors { key message }
    }
  }
`;

const QUERY = gql`
  query billingAccount($accountId: ID!) {
    billingShop(accountId: $accountId) {
      id
      name
    }
    billingSetupPaymentCredentials(accountId: $accountId) {
      clientSecret
    }
  }
`

const withQueries = compose(
  graphql(QUERY, {
    options: (props) => ({
      variables: {
        accountId: props.accountId
      },
      fetchPolicy: "network-only"
    })
  }),
  graphql(ADD_PAYMENT_METHOD, {
    props: ({ mutate }) => ({
      addPaymentMethod: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelAddCreditCard})(withQueries(AddCreditCardFormContainer));

